<p>entity-view-and-edit works!</p>
